import React, { Component } from 'react';
import Card from "../Node/Card";
import CardLoader from "../Elements/CardLoader.js"
import MainCategoryList from "../Elements/MainCategoryList";
import BlockLoader from '../Elements/BlockLoader.js';
class WinnerBlock extends Component {
  constructor() {
    super();
    this.state = {
      /**
       * year tabs
       */
      years: [],
      /**
       * selected year
       */
      currentYear: '',
      /**
       * Best portals
       */
      bestPortalsArray: [],
      /**
       * Win categories
       */
      categories: [],
      /**
       * best portal categories
       */
      bestPortalsCategories: [],
      appRoot: window.location.origin,
      initDone: false,
      isLoadedCard: false,
      /**
       * category group list
       */
      cardByCategoryGroups: [],
      /**
       * category group list with categories data
       */
      categoryGroupsData: [],
    }
  }
  /**
   * Set current year from url
   */
  setUrl = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const queryCategory = urlParams.get('year');
    if (queryCategory) {
      this.setState({
        currentYear: queryCategory,
      });
    }
  }
  /**
   * Get winner category group list
   */
  getCategoryGroupData = async () => {
    try {
      const data = await fetch(`${this.state.appRoot}/jsonapi/taxonomy_term/winner_categories_group?sort=weight`);
      const { data: json } = await data.json();
      const cardByCategoryGroups = json.map(categoryGroup => ({
        id: categoryGroup.id,
        name: categoryGroup.attributes.name,
        fieldWinnerCategories: categoryGroup.relationships.field_winner_categories.data,
      }));
      this.setState({
        cardByCategoryGroups,
      });
    } catch (e) {
      console.error('getCategoryGroupData', e);
    }
  }
  /**
   * Get years to tabs
   */
  getYears = async () => {
    try {
      const data = await fetch(`${this.state.appRoot}/jsonapi/taxonomy_term/years`, { 'method': 'GET' });
      const { data: json } = await data.json();
      const yearTabs = json.map(year => year.attributes.name);
      this.setState({
        years: yearTabs.reverse(),
        currentYear: yearTabs[0],
      });
    } catch (e) {
      console.error('getYears', e);
    }
  }

  /**
   * Get best portals category
   */
  getBestPortals = async () => {
    try {
      const data = await fetch(`${this.state.appRoot}/jsonapi/taxonomy_term/best_portals?sort=-weight`, { 'method': 'GET' });
      const { data: json } = await data.json();
      const bestPortalsCategories = json.map(category => ({
        id: category.id,
        name: category.attributes.name,
      }))
      this.setState({
        bestPortalsCategories,
      });
    } catch (e) {
      console.error('getBestPortals', e);
    }
  }

  /**
   * Get winner categories fields
   */
  getCategories = async () => {
    try {
      const data = await fetch(`${this.state.appRoot}/jsonapi/taxonomy_term/winner_categoryes?sort=weight&include=field_category_badge&fields[file--file]=uri`, { 'method': 'GET' });
      const { data: json, included } = await data.json();
      const categories = json.map((category, index) => ({
        id: category.id,
        name: category.attributes.name,
        weight: category.attributes.weight,
        imageLink: included[index].attributes.uri.url,
      }));

      this.setState({
        categories,
      });
    } catch (e) {
      console.error('getCategories', e);
    } finally {
      this.setState({ isLoadedCard: true });
    }
  }

  /**
   * Get data for cards
   */
  getCardContent = async () => {
    try {
      const data = await fetch(`${this.state.appRoot}/jsonapi/node/nominees?filter[field_year.name]=${this.state.currentYear}&include=field_site_image&fields[file--file]=uri`, { 'method': 'GET' });
      const { data: selectedYearWinners, included } = await data.json();
      const bestPortalsArray = [];

      const categoryGroupWithWinnersData = this.state.cardByCategoryGroups.map((categoryGroup) => {
        const selectedYearWinnerFieldCategory = [];

        categoryGroup.fieldWinnerCategories.forEach((winnerFieldCategory) => {
          this.state.categories.forEach(category => {
            if (winnerFieldCategory.id === category.id) {
              selectedYearWinners.forEach((item, index) => {
                const winnerField = item.relationships.field_winner;

                if (winnerField && winnerField.data) {
                  winnerField.data.forEach((winner) => {
                    if (winner.id === category.id) {
                      selectedYearWinnerFieldCategory.push({
                        id: winnerFieldCategory.id + index,
                        title: item.attributes.title.toString(),
                        sitelink: item.attributes.field_sitelink[0].uri,
                        imageUrl: included[index].attributes.uri.url,
                        alias: item.attributes.path.alias,
                        owner: item.attributes.field_owner.value,
                        category: category.name,
                        categoryBadge: category.imageLink,
                        categoryWeight: category.weight,
                      });
                    }
                  });
                }
              });
            }
          });
        });

        return ({
          ...categoryGroup,
          fieldWinnerCategories: selectedYearWinnerFieldCategory.sort(function (a, b) {
            return a.categoryWeight - b.categoryWeight;
          }), // add categories data (selected year) to the category group
        });
      });

      this.state.bestPortalsCategories.forEach(bestPortalsCategory => {
        selectedYearWinners.forEach((winners, index) => {
          const bestPortalsField = winners.relationships.field_best_portals;
          if (bestPortalsField.data && bestPortalsField.data.id === bestPortalsCategory.id) {
            bestPortalsArray.push({
              id: winners.id,
              title: winners.attributes.title.toString(),
              sitelink: winners.attributes.field_sitelink[0].uri,
              imageUrl: included[index].attributes.uri.url,
              alias: winners.attributes.path.alias,
              owner: winners.attributes.field_owner.value,
              bestPortal: bestPortalsCategory.name,
            });
          }
        });
      });

      this.setState({
        bestPortalsArray: bestPortalsArray.reverse(),
        categoryGroupsData: categoryGroupWithWinnersData,
      });
    } catch (e) {
      console.error('getCardContent', e);
    } finally {
      this.setState({ isLoadedCard: true });
    }
  };

  async componentDidMount() {
    try {
      await this.getYears();
      this.setUrl();
      await this.getCategoryGroupData();
      await this.getCategories();
      await this.getBestPortals();
      await this.getCardContent();
    } catch (e) {
      console.error('componentDidMount', e);
    } finally {
      this.setState({ initDone: true });
    }
  };

  handleCurrentYear = (selectedYear) => {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set('year', selectedYear);
    window.history.replaceState(
      null,
      document.title,
      `${window.location.origin}${window.location.pathname}?${urlParams.toString()}`,
    );

    this.setState({ isLoadedCard: false });
    this.setState({
      currentYear: selectedYear,
    }, () => {
      this.getCardContent();
    });
  };

  render() {
    return (
      <div className="path-winners">
        <div className="tab--years container">
          {this.state.years.map(year => (
            <div
              className={year === this.state.currentYear ? "tab-item active-tab" : "tab-item inactive"}
              onClick={() => this.handleCurrentYear(year)}
              key={year}
            >
              {year}
            </div>
          ))}
        </div>
        <section className="block-views block-views-blockbest-developer-portal-winners-block-1">
          <div className="container form-group">
            <div className="view-content">
              {this.state.bestPortalsArray.length > 0 || this.state.isLoadedCard ? this.state.bestPortalsArray.map((node => (
                <Card key={node.id}
                  bestPortal={node.bestPortal}
                  sitelink={node.sitelink}
                  imageUrl={node.imageUrl}
                  alias={node.alias}
                  owner={node.owner}
                  title={node.title}
                />
              ))) : <CardLoader cardNumber={2} />}
            </div>
          </div>
        </section>
        {this.state.categoryGroupsData.length > 0 || this.state.isLoadedCard ?
          <MainCategoryList categoryGroups={this.state.categoryGroupsData} />
          : <BlockLoader groupNumber={4} cardNumber={3} />
        }
      </div>
    );
  };
};

export default WinnerBlock;
